import { FAIcon, useBreakpoint, Theme } from '@nextgen-web-framework/all';
import HeaderItems from '../headerItems/HeaderItems';
import type { MobileTopHeaderProps } from './types/propsTypes';
import styles from './MobileTopHeader.module.scss';

const MobileTopHeader = (props: MobileTopHeaderProps) => {
  const viewPortType = useBreakpoint();
  const {
    onBackClick,
    title,
    showTitleIcon,
    titleIconName,
    titleIconTheme,
    hasProfileIcon,
    titleLeftAlign = false,
  } = props;
  const onBackButtonClick = (e: React.KeyboardEvent | React.MouseEvent) => {
    if (onBackClick && typeof onBackClick === 'function') {
      onBackClick(e);
    }
  };

  function viewPortSizes() {
    if (props.checkoutTabHeader) {
      return ['xs', 'sm', 'md'];
    } else {
      return ['xs', 'sm'];
    }
  }

  return (
    <>
      {viewPortSizes().includes(viewPortType) ? (
        <header
          className={`${styles['checkout-mobile-header']} ${titleLeftAlign ? styles['left-align-title'] : ''} `}
          data-testid="checkout-mobile-top-header-test-id"
        >
          <div className={styles['checkout-mobile-top-header-left-container']}>
            <FAIcon
              iconName={'chevron-left'}
              className={styles['checkout-mobile-left-icon']}
              data-testid="back-button-test-id"
              onClick={(e) => onBackButtonClick(e)}
            />
          </div>
          {title ? (
            <div className={styles['mobile-top-header-middle-container']} data-testid="checkout-mobile-title-test-id">
              {title}
              {showTitleIcon && (
                <FAIcon
                  iconName={titleIconName ?? 'circle-exclamation'}
                  theme={titleIconTheme ?? Theme.ORANGE}
                  className={styles['checkout-mobile-middle-icon']}
                  data-testid="checkout-mobile-middle-icon-testid"
                />
              )}
            </div>
          ) : (
            <div></div>
          )}
          {hasProfileIcon ? (
            <div
              className={styles['checkout-mobile-top-header-right-container']}
              data-testid="checkout-mobile-right-container-test-id"
            >
              <HeaderItems
                HeaderItemsData={[
                  {
                    id: 'my-account',
                    headerItemIcon: (
                      <FAIcon className={styles['checkout-mobile-right-icon']} iconName={'user-circle'} />
                    ),
                  },
                ]}
              />
            </div>
          ) : (
            <div></div>
          )}
        </header>
      ) : (
        <div className="checkout-desktop-container"></div>
      )}
    </>
  );
};
export default MobileTopHeader;
